/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * User creation request
 */
export interface UserCreationRequest {
  login: string;
  /**
   * Required unless the account is single sign-on only
   */
  password?: string;
  subRole: UserCreationRequest.SubRoleEnum;
  firstName?: string;
  lastName?: string;
  /**
   * Main account and/or subaccount IDs visible to user. Null or empty list means default: all accounts are visible.
   */
  visibleAccountIds?: Array<number>;
}
export namespace UserCreationRequest {
  export const SubRoleEnum = {
    ReadOnly: 'READ_ONLY',
    Trader: 'TRADER',
    TraderPro: 'TRADER_PRO',
  } as const;
  export type SubRoleEnum = (typeof SubRoleEnum)[keyof typeof SubRoleEnum];
}
